import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-stretch flex-nowrap space-x-10 px-10 pt-5 pb-10" }
const _hoisted_2 = { class: "w-1/3" }
const _hoisted_3 = { class: "w-2/3 space-y-5 text-gray-bluer-300 dark:text-gray-blue-300 text-sm p-5" }
const _hoisted_4 = { class: "truncate" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "block font-bold text-gray-bluer-300" }, [
  /*#__PURE__*/_createTextVNode("ID "),
  /*#__PURE__*/_createElementVNode("small", null, "(click to copy)")
], -1)
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "block font-bold text-sm text-gray-bluer-200 dark:text-gray-blue-500 w-full" }, "File Name", -1)
const _hoisted_8 = { class: "truncate" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "block font-bold text-gray-bluer-300" }, [
  /*#__PURE__*/_createTextVNode("URL "),
  /*#__PURE__*/_createElementVNode("small", null, "(click to copy)")
], -1)
const _hoisted_10 = { class: "flex flex-wrap justify-between space-x-10 truncate" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "block font-bold text-sm text-gray-bluer-200 dark:text-gray-blue-500 w-full" }, "File Size", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "block font-bold text-sm text-gray-bluer-200 dark:text-gray-blue-500 w-full" }, "Mime Type", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "block font-bold text-sm text-gray-bluer-200 dark:text-gray-blue-500 w-full" }, "Uploaded", -1)
const _hoisted_14 = { class: "-mx-3 flex" }
const _hoisted_15 = { class: "-mx-3 flex" }
const _hoisted_16 = { class: "-mx-3 flex" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Update ")

import { onMounted, toRefs, computed } from "vue";
import { useStore }                    from "vuex";
import dayjs                      from "dayjs";
import relativeTime               from "dayjs/plugin/relativeTime";
import { MediaModel as Media, fileSize }         from "@greywind/common";
import { useConfig }                   from "../../config";
import { userHook }                    from "@/hooks/user";
import { cloneDeep }                   from "lodash";

import { AppButton as Button } from "@greywind/ui";
import FieldDynamic from "../../../field-dynamic/FieldDynamic.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
        file: {
            type:     Object,
            required: true
        }
    },
  emits: [ 'close', 'created' ],
  setup(__props, { emit }) {

const props = __props

dayjs.extend( relativeTime );

// Components


const { file } = toRefs( props );

const { config }       = useConfig();
const store            = useStore();

const { activeEnvironment } = userHook( store );

const files            = computed( () => store.state.media.files );
const previewComponent = computed( () => {
    switch ( file.value.mime_type ) {
        case 'image/bmp':
        case 'image/gif':
        case 'image/jpeg':
        case 'image/png':
        case 'image/webp':
            return 'ImagePreview';

        case 'application/pdf':
            return 'PdfPreview';

        default:
            return 'NoPreview';
    }
} );

config.value.updatedFile = cloneDeep( file.value );

onMounted( (): void => {
    config.value.url   = `${ activeEnvironment.value.meta.api.url || process.env.VUE_APP_API_URL }/preview`;
    config.value.model = new Media( 'denfield-app-user/denfield-package-media', activeEnvironment.value.meta.api.url );
} );

// Functions
const submitHandler = async (): Promise<void> => {
    config.value.loading = true;
    try {
        delete config.value.updatedFile.type; // used for display only

        if(config.value.updatedFile.people_in_image) {
            config.value.updatedFile.people_in_image = config.value.updatedFile.people_in_image.trim();
        }

        let { data: { data: changedFile } } = await config.value.model.update( config.value.updatedFile.id, config.value.updatedFile );
        changedFile.type                    = 'file'; // put it back!

        const index = files.value.findIndex( f => f.id === changedFile.id );
        if ( index !== -1 ) {
            let fs      = cloneDeep( files.value );
            fs[ index ] = changedFile;

            await store.dispatch( "media/setFiles", fs );
        }

        emit( 'close' );
        emit( 'created' );
    } catch ( { response } ) {
        await store.dispatch(
            "messages/push",
            {
                title:     'File update failed',
                text:      response.data.message,
                theme:     'error',
                icon:      'fontawesome.circle-exclamation',
                closeable: true,
                autoClose: 10000
            }
        );
    } finally {
        config.value.loading = false;
    }
}

const copyToClipboard = ( string: string ): void => {
    navigator.clipboard.writeText( string ).then( () => {
        store.dispatch(
            "messages/push",
            {
                title:     null,
                text:      'Copied to clipboard',
                theme:     'success',
                icon:      null,
                closeable: true,
                autoClose: 5000
            }
        );
    } );
}

const fromNow = ( value: any ): string => {
    return dayjs( value ).fromNow();
}

return (_ctx: any,_cache: any) => {
  const _component_text_field = _resolveComponent("text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(config).url)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(previewComponent)), {
            key: 0,
            file: _unref(file),
            url: _unref(config).url
          }, null, 8, ["file", "url"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", {
          class: "cursor-pointer truncate",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard(_unref(file).id)))
        }, _toDisplayString(_unref(file).id), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, _toDisplayString(_unref(file).name || _unref(file).file_name), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", {
          class: "cursor-pointer truncate",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (copyToClipboard(_unref(file).url)))
        }, _toDisplayString(_unref(file).url), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_unref(fileSize)( _unref(file).size )), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _createElementVNode("span", null, _toDisplayString(_unref(file).mime_type), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("span", null, _toDisplayString(fromNow( _unref(file).created_at )), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_text_field, {
            class: "text-left",
            id: "field-name",
            field: { value: _unref(config).updatedFile.name, label: 'File Name', required: true, stacked: true, name: 'file_name', indexName: 'file_name', extraAttributes: { placeholder: 'File Name' } },
            modelValue: _unref(config).updatedFile.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(config).updatedFile.name) = $event))
          }, null, 8, ["field", "modelValue"]),
          (_unref(file).is_image)
            ? (_openBlock(), _createBlock(_component_text_field, {
                key: 0,
                class: "text-left",
                id: "field-alt",
                field: { value: _unref(config).updatedFile.alt, label: 'File Alt Tag', required: true,  stacked: true, name: 'file_alt', indexName: 'file_alt', extraAttributes: { placeholder: 'File Alt' } },
                modelValue: _unref(config).updatedFile.alt,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(config).updatedFile.alt) = $event))
              }, null, 8, ["field", "modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_text_field, {
            class: "text-left",
            id: "title",
            field: { value: _unref(config).updatedFile.title, label: 'Title', stacked: true, name: 'title', indexName: 'title', extraAttributes: { placeholder: 'Title' } },
            modelValue: _unref(config).updatedFile.title,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(config).updatedFile.title) = $event))
          }, null, 8, ["field", "modelValue"]),
          _createVNode(FieldDynamic, {
            is: 'date-picker',
            id: "date-taken",
            field: { value: _unref(dayjs)(_unref(config).updatedFile.date_taken).format('D/M/YYYY'), meta: { textAlign: 'left' }, stacked: true, field: 'datetime', label: 'Date Taken', name: 'date_taken', attributes: { enableTime: false, altFormat: 'd/m/Y', dateFormat: 'd/m/Y' } },
            modelValue: _unref(config).updatedFile.date_taken,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(config).updatedFile.date_taken) = $event))
          }, null, 8, ["field", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_text_field, {
            class: "text-left",
            id: "people-in-image",
            field: { value: _unref(config).updatedFile.people_in_image, tooltip: 'csv', label: 'People (tags)', name: 'people_in_image', stacked: true, name: 'people_in_image', indexName: 'people_in_image', extraAttributes: { placeholder: 'People' } },
            modelValue: _unref(config).updatedFile.people_in_image,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(config).updatedFile.people_in_image) = $event))
          }, null, 8, ["field", "modelValue"])
        ]),
        _createVNode(_unref(Button), {
          id: "edit-file-button",
          size: "small",
          disabled: !_unref(config).updatedFile.name || !_unref(config).updatedFile.name.length || _unref(config).loading,
          loading: _unref(config).loading,
          theme: "dark",
          onClick: submitHandler
        }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ])
  ]))
}
}

})